export default __webpack_public_path__ + "static/media/040-war.44ea7193.svg";